import { render, staticRenderFns } from "./ksdx.vue?vue&type=template&id=773e0e72"
import script from "./ksdx.vue?vue&type=script&lang=js"
export * from "./ksdx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports